import { type Dispatch } from "@reduxjs/toolkit";
import { SortingDirection } from "enums/sortingDirection";
import { type GetPacksRequest } from "features/Licensing/Packs/types/requests";
import { type Filters } from "utils/queryUtils";
import DataService from "../../../../Application/services/dataServices/typedDataService";
import { fetchBegin, fetchFailure, fetchSuccess } from "../slices/integrationPacksSlice";

export const fetchPacksAction = (accountId: number) => async (dispatch: Dispatch) => {
  dispatch(fetchBegin());
  try {
    const request: GetPacksRequest = {
      top: 10000,
      sortOrder: SortingDirection.Descending,
      skip: 0,
    };
    const filters: Filters = {};

    const result = (await DataService.packs.getAccountPacks(accountId, request, filters)).items;
    const packsMap = result.map((item) => ({ text: item.title, value: item.id }));
    dispatch(fetchSuccess({ items: packsMap, totalCount: result.length }));
  } catch (error) {
    dispatch(fetchFailure(error as Error));
  }
};
